<template>
    <div v-if="loaded" class="tournamentCenterEntrance">
        <Swiper
            v-bind:modules="[EffectFade, Autoplay]"
            v-bind:slidesPerView="ENTRANCE_SLIDES_PER_VIEW"
            v-bind:autoplay="{ delay: 5000, disableOnInteraction: false }"
            v-bind:speed="ENTRANCE_TRANSITION_SPEED"
            effect="fade"
        >
            <SwiperSlide
                v-for="event in entranceEvents"
                v-bind:key="event.eventId"
            >
                <TournamentCenterEntranceSlide
                    v-bind:event="event"
                    class="TC_SportLobby_RotateEntrance"
                    v-on:goToOverview="goToOverview"
                />
            </SwiperSlide>
        </Swiper>
    </div>
</template>

<script lang="ts" setup>
    import orderBy from 'lodash/orderBy';
    import { storeToRefs } from 'pinia';
    import { Autoplay, EffectFade } from 'swiper/modules';
    import { Swiper, SwiperSlide } from 'swiper/vue';
    import { computed } from 'vue';
    import { useRouter } from 'vue-router';
    import TournamentCenterEntranceSlide from './TournamentCenterEntranceSlide.vue';
    import useTournamentCenterEntrance from './useTournamentCenterEntrance';
    import { ENTRANCE_SLIDES_PER_VIEW, ENTRANCE_SLIDE_COUNT, ENTRANCE_TRANSITION_SPEED } from '@/components/tournamentCenter/config';
    import { SportType } from '@/interface/enum';
    import { useTournamentCenterEntranceEvents } from '@/libraries/oddsApi/composables/useTournamentCenterEntranceEventsQuery';
    import { useFeatureToggleStore } from '@/stores/featureToggleStore';

    const { tournamentCenterMainLeagueIds } = storeToRefs(useFeatureToggleStore());

    const { loaded, events } = useTournamentCenterEntranceEvents({
        sportType: SportType.Soccer,
        isMixParlayMode: false,
        tournamentIds: tournamentCenterMainLeagueIds.value,
        isEnabled: true,
        isSubScriptionEnabled: true,
    });

    const entranceEvents = computed(() => {
        const sorted = orderBy(events.value, event => event.absKickoffTime, ['asc']);
        return sorted.slice(0, ENTRANCE_SLIDE_COUNT);
    });

    const router = useRouter();
    const { route } = useTournamentCenterEntrance();

    function goToOverview() {
        router.push(route.value);
    }

</script>

<style lang="scss">
    @import "swiper/css";
    @import "swiper/css/effect-fade";
    @import "@/scss/components/tournamentCenterEntrance";
</style>
